import { Routes } from '@angular/router';
import {
  ApplicantDataSectionComponent,
  ApplicantDataComponentConfig
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataSectionComponent,
  ApplicationDataComponentConfig
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataSectionComponent,
  AgreementsDataComponentConfig
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import {
  LocationDataComponentConfig,
  LocationDataSectionComponent
} from '../common/location-data-section/location-data-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Lokalizacja',
  'Inwestor',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  applicationSubjectControlType: 'select',
  successUrl: '../lokalizacja',
  addApplicationSubjectControl: true,
  addExitTypeControl: true,
  addExitDirectionControl: true,
  cancelUrl: '../wnioskodawca'
};

export const locationDataSectionConfig: LocationDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../wykonawca',
  addPostInvestmentUsageControls: true
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../lokalizacja',
  customTitles: {
    sectionTitle: 'Inwestor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    cardTitle2: 'Edytuj inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych wykonawców!'
  }
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../wykonawca',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const locationReconstructionOfExitRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: LocationDataSectionComponent,
    path: ':appId/lokalizacja',
    data: locationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/wykonawca',
    data: contractorDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
